import React, { useCallback, useMemo } from 'react';
import { Form, PrimaryButton } from '@kallidus/common';
import SessionOutFormFields from './SessionOutFormFields';
import { useLazyQuery } from '@apollo/client';
import LOGIN_QUERY from '@Queries/login.graphql';
import { func } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { LoginFormError } from '@Generic/LoginFormErrors/LoginFormError';
import { useLoggedInUser } from '@ApplicationWide/AppConfig';
import LoginWithSSO from '../../../pages/Auth/LoginWithSSO';
import { usePreAuthConfig } from '@ApplicationWide/auth/usePreAuthConfig';
import './SessionOutForm.less';

export default function SessionOutForm({ onIdle, onClose }) {
  const { t } = useTranslation();
  const preAuthConfig = usePreAuthConfig();

  const showSsoBasedLoginOption = preAuthConfig.loginOptions?.showSsoBasedLoginOption;

  const { user } = useLoggedInUser();
  const [login, { error, loading }] = useLazyQuery(LOGIN_QUERY, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      onClose();
      onIdle(false);
    },
  });

  const handleSessionButtons = useCallback(() => {
    return (
      <>
        <PrimaryButton loading={loading} type='submit'>
          {t('auth.buttons.login')}
        </PrimaryButton>
        {showSsoBasedLoginOption && <LoginWithSSO />}
      </>
    );
  }, [loading, showSsoBasedLoginOption, t]);

  const handleSubmit = useCallback(
    async ({ username, password }) => {
      try {
        login({
          variables: { username, password },
        });
      } catch (e) {
        return {};
      }
    },
    [login],
  );

  return useMemo(
    () => (
      <Form
        onSubmit={handleSubmit}
        validateOnBlur={false}
        renderButtons={handleSessionButtons}
        initialValues={{ username: user?.email }}
      >
        <SessionOutFormFields />
        <LoginFormError errorCode={error?.message} />
      </Form>
    ),
    [error?.message, handleSessionButtons, handleSubmit, user?.email],
  );
}

SessionOutForm.propTypes = {
  onIdle: func,
  onClose: func,
};
